import { actionModels, getActionModelLabel, recordTypeActionModelOptions } from '../../../../actionModels.js';
import { detectAppChanges } from '../../../lib/detectAppChanges.js';

const modelOptions = recordTypeActionModelOptions;

export const appActionModel = {
  key: 'model', //
  type: 'app',
  label: 'Record Type',
  description: 'What type of record this action is interacting with.',
  path: 'actions[id:{{actionId}}].model',
  shouldRun: ({ changes, actionId }) =>
    detectAppChanges(changes, {
      type: 'action',
      actionId,
      keys: ['', 'name', 'description', 'slug', 'model', 'operation']
    }),
  mapContext: ({ app, action }) => ({
    name: action?.name,
    model: action?.model,
    operation: action?.operation || 'none',
    availableModels: modelOptions,
    slug: action?.slug,
    appName: app?.name
  }),
  formatLabel: (value) => getActionModelLabel(value),
  postProcess: ({ suggestion }) => {
    const suggestedModel = suggestion?.suggestion?.suggestedValue;
    if (suggestedModel && !actionModels[suggestedModel]) {
      return (suggestion.suggestion.suggestedValue = undefined);
    }
    return { ...suggestion };
  },
  prompt: 'appActionModel'
};
